import React from 'react'

import ErrorBoundary from '../../../../components/FundDetails/Modules/Performance/ErrorBoundary.jsx'

import {
  getMutualFundClassMetadata,
  getMutualFundData,
  getDownloadCapGains,
} from '../InvestmentProductsDataSource.js'

import MutualFunds from './MutualFunds.jsx'
import ClassOptions from '../ClassOptions.jsx'
import MutualFundsPerformanceOptions from './MutualFundsPerformanceOptions.jsx'
import MorningstarOptions from '../MorningstarOptions.jsx'

export function MutualFundsContainer() {
  return (
    <div>
      <ErrorBoundary
        title="Mutual Funds"
        message="Mutual Fund information is currently unavailable due to a technical issue. Please try again later."
        isConstrained={true}
      >
        <MutualFunds
          getData={getMutualFundData}
          getMetadata={getMutualFundClassMetadata}
          getDownloadCapGains={getDownloadCapGains}
          rootNode="mutualFunds"
          classOptions={ClassOptions}
          performanceOptions={MutualFundsPerformanceOptions}
          morningstarOptions={MorningstarOptions}
        />
      </ErrorBoundary>
    </div>
  )
}
